var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uE9F7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.596 16 .577-.673c.487-.577.949-1.167 1.385-1.77a36.785 36.785 0 0 0 1.673-2.48c.59-1 1.051-1.93 1.384-2.789.385-1.012.577-1.91.577-2.692 0-1.025-.25-1.968-.75-2.827A5.644 5.644 0 0 0 8.423.75 5.519 5.519 0 0 0 5.596 0C4.571 0 3.628.25 2.77.75A5.644 5.644 0 0 0 .75 2.77C.25 3.627 0 4.57 0 5.595c0 .782.192 1.68.577 2.692.333.86.795 1.789 1.385 2.789a36.785 36.785 0 0 0 1.673 2.48c.436.603.897 1.193 1.384 1.77l.577.673Zm0-8.423A1.91 1.91 0 0 1 4.192 7a1.91 1.91 0 0 1-.577-1.404c0-.359.09-.692.27-1 .18-.308.42-.551.72-.73a1.9 1.9 0 0 1 .991-.27c.36 0 .692.09 1 .27a1.998 1.998 0 0 1 1 1.73c0 .36-.09.69-.27.99-.179.302-.422.542-.73.722a1.95 1.95 0 0 1-1 .269Z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRegular);
export default __webpack_public_path__ + "static/media/location-regular.1da5f8db14bad42c5d2bbd38f6abb00e.svg";
export { ForwardRef as ReactComponent };